var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProspectus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1853B4",
    d: "M16 0c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4H4c-2.21 0-4-1.79-4-4V4c0-2.21 1.79-4 4-4h12zm0 .667H4C2.207.667.745 2.082.67 3.855L.667 4v12c0 1.793 1.415 3.255 3.188 3.33l.145.003h12c1.793 0 3.255-1.415 3.33-3.188l.003-.145V4c0-1.793-1.415-3.255-3.188-3.33L16 .667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A19",
    d: "M3.627 12.75v-2.113h1.336c.984 0 1.728-.672 1.728-1.64 0-.872-.672-1.584-1.704-1.584h-2.32v5.336h.96zm1.168-2.937H3.627v-1.6h1.12c.744 0 .936.424.936.808 0 .488-.344.792-.888.792zm3.624 2.936v-2.192H9.77l.832 2.192h1.016l-.936-2.352c.696-.296.96-.776.96-1.416 0-.928-.616-1.568-1.784-1.568h-2.4v5.336h.96zm1.224-2.96H8.419V8.181h1.304c.552 0 .92.312.92.784 0 .544-.384.824-1 .824zm4.928 3.04c1.408 0 2.288-1.12 2.288-2.752 0-1.592-.888-2.744-2.248-2.744-1.36 0-2.288 1.192-2.288 2.728 0 1.456.736 2.768 2.248 2.768zm-.032-.776c-.688 0-1.176-.616-1.176-1.968 0-1.312.424-1.976 1.248-1.976 1.008 0 1.208 1.096 1.208 2.024 0 1.52-.608 1.92-1.28 1.92z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProspectus);
export default __webpack_public_path__ + "static/media/prospectus.296d2a0f64d7a0565d21b3cd378bc3a6.svg";
export { ForwardRef as ReactComponent };